module.exports = __webpack_public_path__ + "img/Moduuli_1_tase.c5ab3f87.png";